import Component from '../../js/_Component';

const CNAME = 'c-block-newsletter-form';

export default class BlockNewsletterForm extends Component {
	private form: HTMLFormElement;

	private input: HTMLInputElement;

	private successMessage: HTMLElement;

	private failureMessage: HTMLElement;

	constructor(element: HTMLElement) {
		super(element);

		// This was going to post to an endpoint, converted to use campaign monitor
		/*
		this.form = element.querySelector(`.${CNAME}--form`);
		this.input = element.querySelector(`.${CNAME}--input`);
		this.successMessage = element.querySelector(`.${CNAME}--message.m-success`);
		this.failureMessage = element.querySelector(`.${CNAME}--message.m-failure`);

		this.form.addEventListener('submit', (event) => {
			event.preventDefault();
			this.submit();
		});
		*/
	}

	submit() {
		const data = {email: this.input.value};

		const fetchOptions = {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify(data),
		};

		fetch('/api/xxx.php', fetchOptions)
			.then((response) => response.json())
			.then((response) => this.onSuccess(response))
			.catch(() => this.onFailure());
	}

	onSuccess(response) {
		if (!response.success) {
			this.onFailure();
			return;
		}

		this.form.style.display = 'none';
		this.successMessage.style.display = 'block';
	}

	onFailure() {
		this.form.style.display = 'none';
		this.failureMessage.style.display = 'block';
	}
}

Component.register(BlockNewsletterForm, 'BlockNewsletterForm');
